import moment from 'moment';
import momentTZ from 'moment-timezone';

import datesConfig from './datesConfig.json';
import timeZones from './timeZones.json';

const { DATE_FORMATS, DEFAULT_TIMEZONE } = datesConfig;

let timezone = DEFAULT_TIMEZONE;

// Fix the old non standard ISO dates
function fixDate(date) {
  if (!date) {
    return date;
  }

  let modifiedDate = date;

  // YYYY-MM-DD format
  if (date.length === 10) {
    modifiedDate = modifiedDate.replace(/-/g, '');
  }

  // YYY-MM-DD[T]HH:mm:sss[Z] format
  if (date.length === 21) {
    modifiedDate = modifiedDate.split('T')[0].replace(/-/g, '');
  }

  return modifiedDate;
}

function momentDate(date) {
  return moment(fixDate(date));
}

function formatDate(date, format = DATE_FORMATS.LONG) {
  return momentDate(date).format(format);
}

function utcDate(date) {
  return moment(fixDate(date)).utc();
}

function formatUtcDate(date, format = DATE_FORMATS.LONG) {
  return utcDate(date).format(format);
}

function timezoneDate(date, tz = timezone) {
  return momentTZ(fixDate(date)).tz(tz);
}

function formatTZDate(date, format = DATE_FORMATS.LONG, tz = timezone) {
  return timezoneDate(date, tz).format(format);
}

function setTimezone(tz) {
  timezone = tz;
}

function getDatesDifferences(date1, date2) {
  return moment
    .utc(date1)
    .startOf('day')
    .diff(moment.utc(date2).startOf('day'));
}

function getTZDifference() {
  const now = moment()
    .utc()
    .format(DATE_FORMATS.DSL);
  const differenceInMinutes = momentTZ.tz.zone(timezone).parse(now);
  // convert to seconds
  return -differenceInMinutes * 60;
}

function getTZOffset(tz = timezone) {
  return momentTZ()
    .tz(tz)
    .format('Z');
}

const timeZonesDropdownValues = Object.keys(timeZones).reduce((prev, key) => {
  prev.push({
    id: key,
    value: timeZones[key].replace('#offset', getTZOffset(key)),
  });

  return prev;
}, []);

function emailDate(date) {
  let format = DATE_FORMATS.EMAIL_SHORT;

  if (momentDate().diff(momentDate(date), 'years') > 0) {
    format = DATE_FORMATS.EMAIL_LONG;
  } else if (momentDate().diff(momentDate(date), 'days') > 0) {
    format = DATE_FORMATS.EMAIL_MEDIUM;
  }

  return formatTZDate(date, format);
}

function prettyDate(date) {
  return moment(date)
    .utc()
    .fromNow();
}

function formatISODate(date) {
  return date.format('YYYY-MM-DD');
}

export {
  moment,
  momentTZ,
  DATE_FORMATS,
  DEFAULT_TIMEZONE,
  datesConfig,
  timeZones,
  timeZonesDropdownValues,
  momentDate,
  formatDate,
  utcDate,
  formatUtcDate,
  timezoneDate,
  formatTZDate,
  setTimezone,
  prettyDate,
  getDatesDifferences,
  getTZDifference,
  getTZOffset,
  emailDate,
  formatISODate,
};
